import { isFiniteNumber } from './number';

/**
 * Randomizes the items of an array by reference.
 * @param sourceArray
 */
export function shuffle(sourceArray: Array<any>) {
  for (let i = 0; i < sourceArray.length - 1; i++) {
    const j = i + Math.floor(Math.random() * (sourceArray.length - i));

    const temp = sourceArray[j];
    sourceArray[j] = sourceArray[i];
    sourceArray[i] = temp;
  }

  return sourceArray;
}

/**
 * Generates an array of ascending numbers from 1 to n.
 *
 * @param {number} n - The number up to which the array should be filled.
 * @return {number[]} - An array filled with numbers from 1 to n in ascending order.
 *
 * @example
 * generateAscendingArray(3) -> Returns [1, 2, 3]
 *
 */
export const generateAscendingArray = (n: number): number[] => {
  const array: number[] = [];

  if (!n) return array;
  if (!isFiniteNumber(n)) return array;
  if (n < 1) return array;

  for (let i = 1; i <= n; i++) {
    array.push(i);
  }
  return array;
};
